import type { components } from '@connected/api-client/api.generated';

import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { useQuery } from '@tanstack/react-query';

import type { ObservationParentKinds } from '../utils/observation-types';

export type UseStandardTextsProps = {
    electricalProjectVersionId: string;
    parentKind: ObservationParentKinds;
};

export function useStandardTexts(props: UseStandardTextsProps): components['schemas']['ListElectricalObservationStandardTextItemForProjectQueryResult'] {
    const { electricalProjectVersionId, parentKind } = props;

    const { data: standardTexts } = useQuery(elektraAppQueryOptions.project.inspection.observations.standardTextsGetOptions({
        electricalProjectVersionId,
        objectKind: parentKind,
    }));

    return {
        Items: standardTexts?.Items || [],
    };
}
